interface ActionTypes {
  GET_ADDRESS_SUGGESTION_START: string;
  GET_ADDRESS_SUGGESTION_SUCCESS: string;
  GET_ADDRESS_SUGGESTION_FAILURE: string;
  GET_ADDRESS_CANDIDATE_START: string;
  GET_ADDRESS_CANDIDATE_SUCCESS: string;
  GET_ADDRESS_CANDIDATE_FAILURE: string;
  GET_LOT_NUM_SUGGESTION_START: string;
  GET_LOT_NUM_SUGGESTION_SUCCESS: string;
  GET_LOT_NUM_SUGGESTION_FAILURE: string;
  CLEAR_ADDRESS_SUGGESTION: string;
  CLEAR_ADDRESS_CANDIDATE: string;
}

export const MapLocationSearchActionTypes: ActionTypes = {
  GET_ADDRESS_SUGGESTION_START: '@@GET_ADDRESS_SUGGESTION_START',
  GET_ADDRESS_SUGGESTION_SUCCESS: '@@GET_ADDRESS_SUGGESTION_SUCCESS',
  GET_ADDRESS_SUGGESTION_FAILURE: '@@GET_ADDRESS_SUGGESTION_FAILURE',
  GET_ADDRESS_CANDIDATE_START: '@@GET_ADDRESS_CANDIDATE_START',
  GET_ADDRESS_CANDIDATE_SUCCESS: '@@GET_ADDRESS_CANDIDATE_SUCCESS',
  GET_ADDRESS_CANDIDATE_FAILURE: '@@GET_ADDRESS_CANDIDATE_FAILURE',
  GET_LOT_NUM_SUGGESTION_START: '@@GET_LOT_NUM_SUGGESTION_START',
  GET_LOT_NUM_SUGGESTION_SUCCESS: '@@GET_LOT_NUM_SUGGESTION_SUCCESS',
  GET_LOT_NUM_SUGGESTION_FAILURE: '@@GET_LOT_NUM_SUGGESTION_FAILURE',
  CLEAR_ADDRESS_SUGGESTION: '@@CLEAR_ADDRESS_SUGGESTION',
  CLEAR_ADDRESS_CANDIDATE: '@@CLEAR_ADDRESS_CANDIDATE'
};

export interface MapLocationSearchState {
  suggestion: ArcGISWorldGeocodingSuggestion[];
  suggestionError: string;
  addressCandidate?: __esri.AddressCandidate[] | null;
  addressCandidateError?: string;
}

export interface ArcGISWorldGeocodingSuggestion {
  text: string;
  magicKey: string;
  isCollection: boolean;
}

export default MapLocationSearchActionTypes;
